import React from "react";
import { Field, ErrorMessage } from "formik";

export default function PersonalDetailsForm({ formik }) {
  return (
    <div
      className="col-12 my-0 rounded-3 p-4"
      style={{
        border: "1px solid #e9ecef",
        backgroundColor: "#fff",
      }}
    >
      <h4 className="fw-bold mb-4">Personal Details</h4>
      <div className="alert alert-info shadow-sm">
        <h6 className="fw-bold mb-3">Name Entry Guidelines</h6>
        <p className="mb-2">
          <strong>Full Name: </strong>
          This refers to your complete name as it appears on your{" "}
          <strong>Birth Certificate</strong> or <strong>Passport</strong>.
        </p>
        <em>Example:</em> Rajapaksha Mudiyanselage Charith Madushanka Perera
        <p className="my-2">
          <strong>Calling Name: </strong>
          This will be the name used in the system. All emails and messages will
          be addressed to you using this name. You can select your preferred
          calling name.
        </p>
        <em>Example:</em>
        <ul className="mb-0">
          <li>Charith Madushanka</li>
          <li>Charith Perera</li>
          <li>Madushanka Perera</li>
          <li>Charith Rajapaksha</li>
          <li>Madushanka Rajapaksha</li>
        </ul>
      </div>

      {/* Full Name */}
      <div className="col-12 mb-3">
        <label className="form-label">
          Full Name<span className="text-danger">*</span>
        </label>
        <Field type="text" className="form-control" name="fullName" />
        <ErrorMessage name="fullName" component="div" className="text-danger" />
      </div>

      {/* Calling Name */}
      <div className="col-12 mb-3">
        <label className="form-label">
          Calling Name<span className="text-danger">*</span>
        </label>
        <Field type="text" className="form-control" name="callingName" />
        <ErrorMessage
          name="callingName"
          component="div"
          className="text-danger"
        />
      </div>

      {/* NIC Number */}
      <div className="col-12 mb-3">
        <label className="form-label">
          NIC Number<span className="text-danger">*</span>
        </label>
        <Field type="text" className="form-control" name="nicNumber" />
        <ErrorMessage
          name="nicNumber"
          component="div"
          className="text-danger"
        />
      </div>

      {/* Date of Birth */}
      <div className="col-12 mb-3">
        <label className="form-label">
          Date of Birth<span className="text-danger">*</span>
        </label>
        <Field type="date" className="form-control" name="dateOfBirth" />
        <ErrorMessage
          name="dateOfBirth"
          component="div"
          className="text-danger"
        />
      </div>

      {/* Portrait Upload */}
      <div className="col-12 mb-3">
        <label className="form-label">
          Photograph<span className="text-danger">*</span>
        </label>
        <input
          type="file"
          className="form-control"
          accept="image/*"
          onChange={(e) => {
            formik.setFieldValue("portrait", e.currentTarget.files[0]);
          }}
        />
        {formik.values.portrait && (
          <small className="text-success">{formik.values.portrait.name}</small>
        )}
        <ErrorMessage name="portrait" component="div" className="text-danger" />
      </div>
    </div>
  );
}
